let  state = {
    cartGoodsList:[],                   // 购物车中的商品列表
    cartGoodsCount: function () { // 商品数量
        if(this.cartGoodsList){
            var goodsNumber = 0;
            this.cartGoodsList.forEach(element => {
							if (element && element.quantity && element.available && element.inventory > 0) {
								goodsNumber+= Number(element.quantity);
							}
            });
            return goodsNumber
        }else{
            return 0;
        }
    },
    // 商品总价格
    cartPriceSum: function () { // 商品数量
        let sum = 0;
		this.cartGoodsList.forEach(product => {
			if (product && product.price && product.available  && product.inventory > 0) {
				sum += parseFloat(product.price) * (product.quantity ? product.quantity: 1 );
			}
        });
        return sum.toFixed(2)
    },
    // cartPriceSum: 0.00,
}
export default state;


// WEBPACK FOOTER //
// ./src/reducers/cartReducers/state.js